
import { Component, Prop, Vue } from 'vue-property-decorator';

import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";
import { schedule2DataInfoType } from '@/types/Application/PriorityParentingMatter/PDF';

@Component({
    components:{
        UnderlineForm,
        CheckBox
    }
})

export default class Schedule2 extends Vue {

    @Prop({required:true})
    result!: any;

    dataReady = false;
    scheduleInfo = {} as schedule2DataInfoType;     
   
    mounted(){
        this.dataReady = false;
        this.extractInfo();       
        this.dataReady = true;
    } 

    public extractInfo(){
        this.scheduleInfo = this.getSchedule2Info();        
    }

    public getSchedule2Info() {

        let schedule2Info = {} as schedule2DataInfoType; 
        schedule2Info.ancestryType = [];
        schedule2Info.understandFileForm5 = true;

        if (this.result?.ppmIndigenousAncestryOfChildSurvey){
            const ancestryData = this.result?.ppmIndigenousAncestryOfChildSurvey;
            schedule2Info.isFirstNations = ancestryData.indigenousChild
            if (schedule2Info.isFirstNations == 'yes'){
                schedule2Info.ancestryType = ancestryData.indigenousAncestry;
                if (schedule2Info.ancestryType.includes('Nisg̲a’a') || schedule2Info.ancestryType.includes('Treaty First Nation')){
                    schedule2Info.understandFirstNationsService = ancestryData.ServeAcknowledgement && ancestryData.ServeAcknowledgement == "I acknowledge";
                }
            }            
        }

        if (this.result?.ppmAdditionalDocumentsSurvey){
            const ppmAdditionalDocData = this.result.ppmAdditionalDocumentsSurvey;
            schedule2Info.initiatedCriminalCheck = ppmAdditionalDocData.criminalChecked == 'y';
            schedule2Info.filingRequiredDocs = ppmAdditionalDocData.isFilingAdditionalDocs == 'y';
            if (ppmAdditionalDocData.isFilingAdditionalDocs == 'n' && ppmAdditionalDocData.unableFileForms){

                schedule2Info.fileRequest = !ppmAdditionalDocData.unableFileForms.includes("Completed  <a class='mr-1' href='https://www2.gov.bc.ca/assets/gov/law-crime-and-justice/courthouse-services/court-files-records/court-forms/family/pfa914.pdf?forcedownload=true' target='_blank' > Request for protection order registry search </a> form");
                schedule2Info.fileConsent = !ppmAdditionalDocData.unableFileForms.includes("Completed  <a class='mr-1' href='https://www2.gov.bc.ca/assets/gov/law-crime-and-justice/courthouse-services/court-files-records/court-forms/supreme-family/s-51-consent-child-protection-record-check.pdf?forcedownload=true' target='_blank' > Consent for Child Protection Record Check Form 5 </a> <i> Family Law Act Regulation </i>");

            } else if (ppmAdditionalDocData.isFilingAdditionalDocs == 'y'){

                schedule2Info.fileRequest = true;
                schedule2Info.fileConsent = true;
            }

            schedule2Info.filingRequiredDocs = ppmAdditionalDocData.isFilingAdditionalDocs == 'y' || 
                                               (ppmAdditionalDocData.isFilingAdditionalDocs == 'n' && 
                                               (schedule2Info.fileConsent || schedule2Info.fileRequest))
        }
      
        return schedule2Info;
    }

}
